<template>
    <div class="school-and-date unit" :class="onlyOneTitle ? 'only-one' : ''">
        <span>{{ handleDeptName(schoolName) }}</span>
        <span :class="onlyOneTitle ? 'only-one' : ''">{{ onlyOneTitle }}</span>
        <span>{{ dateTime || '' }}</span>
    </div>
</template>
<script>
import { handleDeptName } from "@/assets/js/mock";
import { getQueryObjByUrl } from "@/assets/js/common";
import { TAB_MAP_VALUE, SPECIAL_ONE } from "@/assets/js/constants";
export default {
    name: 'schoolAndDate',
    props: {
        schoolName: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(to) {
                console.log('===> 组件schoolAndDate 监听route <==', to)
                this.handleOnlyOneLayout()
            },
        }
    },
    data() {
        return {
            // 只有一个标题的样式排版
            onlyOneTitle: '',
        }
    },
    created() {
        this.handleOnlyOneLayout()
    },
    mounted() { },
    methods: {
        handleDeptName,
        handleOnlyOneLayout() {

            try {
                const { item, onlyOne } = getQueryObjByUrl()
                const itemArr = item.split(',')
                if (itemArr.length === 1) {
                    this.onlyOneTitle = TAB_MAP_VALUE[item] || ''
                } else {
                    this.onlyOneTitle = ''
                }

                if (onlyOne === '1' || [SPECIAL_ONE].includes(itemArr[0])) {
                    this.onlyOneTitle = ''
                }

            } catch (error) {
                this.onlyOneTitle = ''
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.unit {
    position: absolute;
    left: 0;
    right: 0;
    top: vh(-30);
    margin: auto;
    width: 100%;
    color: #FFF;
    font-size: vh(16);
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &.only-one {
        position: static;
        margin: vh(-20) auto 0;
        padding: vh(20) 0 vh(30);
        background-color: #00048f;
    }

    >span {
        display: inline-block;
        flex: 1;
        color: #3CEAFF;
        font-weight: 100;
    }

    >span:nth-of-type(1) {
        text-align: left;
    }

    >span:nth-of-type(2) {
        font-size: 0;
        font-weight: bold;
        color: #3CEAFF;

        &.only-one {
            font-size: vh(30);
            transform: translateY(vh(-5));
        }
    }

    >span:nth-of-type(3) {
        text-align: right;
    }

}
</style>